import { Account } from '@adsk/alloy-provider';

export default function getMinEnabledIdleDuration(accounts: Account[]) {
  return accounts
    .filter(
      (account) =>
        account?.idle_timeout?.enabled && account?.idle_timeout?.duration,
    )
    .reduce<number | undefined>((minDuration, account) => {
      if (
        !minDuration ||
        (account.idle_timeout?.duration &&
          account.idle_timeout?.duration < minDuration)
      ) {
        return account.idle_timeout?.duration;
      }
      return minDuration;
    }, undefined);
}
